import { Pipe, PipeTransform } from '@angular/core';
import { MemberSubmission } from '../../../models/submissions/member-submission';
import { SubmissionStatusIdEnum } from '../../../models/enum/shared/submission-status-id.enum';
import * as moment from 'moment';
import { SubmissionUtils } from '../../../utils/submission-utils';
import { EpEmployerSubmission } from '../../../models/submissions/employer-submissions/ep-employer-submission';
import { IpEmployerSubmission } from '../../../models/submissions/employer-submissions/ip-employer-submission';
import { EmployerMemberSubmission } from '../../../models/submissions/employer-submissions/employer-member-submission';

@Pipe({
  name: 'submissionStatusDateString',
  standalone: true
})
export class SubmissionStatusDateStringPipe implements PipeTransform {
  transform(
    submission: MemberSubmission | EpEmployerSubmission | IpEmployerSubmission | EmployerMemberSubmission
  ): string {
    const relevantDate = SubmissionUtils.getRelevantDate(submission);
    const formattedDate = this.getFormattedDate(relevantDate);
    if (submission.isApproved()) {
      return $localize`Approved On ${formattedDate}`;
    }
    switch (submission.statusId) {
      case SubmissionStatusIdEnum.Pending:
        return $localize`Created on ${formattedDate}`;
      case SubmissionStatusIdEnum.Cancelled:
        return $localize`Cancelled on ${formattedDate}`;
      case SubmissionStatusIdEnum.Completed:
        return $localize`Completed on ${formattedDate}`;
      case SubmissionStatusIdEnum.Submitted:
      case SubmissionStatusIdEnum.InReview:
        return $localize`Submitted on ${formattedDate}`;
      default:
        return '';
    }
  }

  private getFormattedDate(date: string | null): string {
    return moment(date).format('MMMM D, YYYY');
  }
}
